var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.79 113.487C217.65 132.637 217.91 137.167 217.79 156.307C187.1 174.017 156 192.287 125.31 209.987V155.118C156.12 141.248 186.96 127.357 217.79 113.487Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97.4874V166.348L125.37 209.987V147.557L79.6901 74.8976L34 97.4874Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0801 100.188L33.8101 107.287L79.67 74.8976C100.12 104.458 120.55 133.997 141 163.557C171.69 146.897 202.38 130.258 233.06 113.608C212.69 81.0475 192.34 48.4576 171.97 15.8976C141.2 29.5176 110.43 43.1274 79.67 56.7374L18.0801 100.188Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 235.598L117.45 231.088L107.83 225.358L34 181.338V158.858L125.37 209.957L125 235.598Z",
    fill: "#FECECA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2101 74.3175L33.8101 107.287L126.11 155.467L80.2101 74.3175Z",
    fill: "#FECECA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.63 180.467V156.307L125.38 209.888L125 235.598L217.63 180.467Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0801 100.188L33.8101 107.287L79.67 74.8976L125.33 155.118L141 163.557L79.67 56.7574L18.0801 100.188Z",
    fill: "#72D09A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6901 110.057L57.8501 108.487L59.4801 109.697L55.89 114.537L51.78 109.757L53.3201 108.438L54.66 109.997V101.938H56.6901V110.057Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.08 122.227L81.24 120.658L82.87 121.868L79.2699 126.717L75.1699 121.928L76.71 120.608L78.0499 122.168V114.108H80.08V122.227Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.48 133.818L103.65 132.257L105.28 133.467L101.68 138.307L97.5701 133.517L99.1201 132.197L100.46 133.757V125.697H102.48V133.818Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9 206.297L98.7401 207.868L97.1101 206.658L100.71 201.807L104.81 206.598L103.27 207.918L101.93 206.358V214.418H99.9V206.297Z",
    fill: "#F97E73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7802 191.797L73.6202 193.368L71.9902 192.158L75.5902 187.307L79.6902 192.098L78.1501 193.418L76.8102 191.858V199.918H74.7802V191.797Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9199 179.188L51.7599 180.757L50.1299 179.547L53.72 174.707L57.83 179.487L56.2899 180.807L54.95 179.247V187.307H52.9199V179.188Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.53 205.348L153.69 206.918L155.32 205.707L151.72 200.868L147.62 205.648L149.16 206.967L150.5 205.408V213.467H152.53V205.348Z",
    fill: "#FECECA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.65 190.848L178.81 192.418L180.44 191.207L176.84 186.358L172.74 191.148L174.28 192.467L175.62 190.908V198.967H177.65V190.848Z",
    fill: "#FECECA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.51 178.247L200.67 179.807L202.3 178.598L198.71 173.757L194.6 178.547L196.14 179.868L197.48 178.297V186.358H199.51V178.247Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricB);
export default __webpack_public_path__ + "static/media/electricB.35148b27264cf25c83849895ce6125dc.svg";
export { ForwardRef as ReactComponent };